import React from 'react';

const AboutUsContent = () => (
  <div className="min-h-screen bg-gray-50 ">
    <div className="max-w-7xl mx-auto ">
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        {/* Header */}
        <div className="bg-accent text-white px-6 py-8">
          <h1 className="text-3xl font-bold text-center text-white">About Us</h1>
          <p className="text-center mt-2 text-white/90">
            AIM Journal of Homoeopathic Medicine
          </p>
        </div>

        {/* Content */}
        <div className="px-6 py-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              <strong>AIM Journal of Homoeopathic Medicine</strong> is a peer-reviewed research journal devoted to advancing the science and practice of classical and modern homeopathy. Our mission is to bridge traditional principles with rigorous contemporary investigation, supporting evidence‑based approaches.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Founded by leading experts in the field, we publish high-quality original research, systematic reviews, clinical trials, case series, and theoretical studies. These span topics including individualized remedies, complex potencies, and new indications like respiratory care (e.g. homeopathy's role in mild COVID-19 cases), dermatology, mental health, and lymphatic conditions like allergic rhinitis and asthma.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Our editorial board comprises experienced clinicians and researchers committed to the scientific integrity and clinical relevance of every publication. With a thorough peer-review process, we aim to:
            </p>
            
            <ul className="list-disc ml-8 mb-6 text-gray-700 space-y-2">
              <li>
                Promote robust clinical evidence—such as recent meta-analyses demonstrating significant effects beyond placebo in individualized homeopathy
                <a href="https://pmc.ncbi.nlm.nih.gov" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline ml-1">pmc.ncbi.nlm.nih.gov</a>.
              </li>
              <li>
                Encourage methodologically sound clinical trials, case studies, and lab-based investigations that explore potencies, proving methods, and new applications.
              </li>
              <li>
                Support ongoing education and professional development by providing access to webinars, case snapshot series, and special thematic issues curated by domain experts.
              </li>
            </ul>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              AIM Journal of Homoeopathic Medicine serves as a global platform—highlighting innovations from practitioners and researchers across India, Europe, and beyond. We invite authors to contribute original manuscripts, systematic reviews, in-depth case analyses, and letters to the editor.
            </p>
            
            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">Editorial Policies & Submission</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Submissions undergo rigorous peer review with transparent guidelines to ensure ethical conduct and methodological quality. Full instructions for authors are available on our site, outlining scope, formatting, and disclosure standards.
            </p>
            
            <p className="text-gray-700 leading-relaxed">
              By spotlighting clinical excellence, scientific rigor, and integrative scholarship, AIM Journal of Homoeopathic Medicine aspires to advance the credibility and reach of homeopathic research in today's healthcare landscape.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AboutUsContent; 